import gql from 'graphql-tag';

const subscriptionQuery = gql`
  query subscriptionQuery(
    $dealerNumbers: String
    $page: Int
    $size: Int
    $offset: Int
    $view: String
    $productFamily: String
  ) {
    subscription(
      dealerNumbers: $dealerNumbers
      page: $page
      size: $size
      offset: $offset
      view: $view
      productFamily: $productFamily
    ) {
      id
      subscription_id
      dealerName
      dealerNumber
      productId
      productName
      productFamily
      subscriptionType
      priceDs
      pricePsiLpi
      notifyEmail
      networkPlusRate
      active
      startDate
      endDate
      dealerName
      dsPaidPsi
      discountedPricing
      subscriptionCancellationReason
      priceStartDate
    }
  }
`;

export default subscriptionQuery;
